import { ExtendedOperatorType } from 'src/Types/ClientModelTypes';
import {
  IExtendedConditionObject,
  IUIPage,
  IExtendedCondition,
} from 'src/Types/UrvalTypes';
import { set, setCondition } from './UrvalConditionObjectUtils';
import { update } from 'ramda';

export const setExtendedOperator = (
  conditionIndex: number,
  newOperator: ExtendedOperatorType,
  conditionObject: IExtendedConditionObject
): IExtendedConditionObject => {
  const newCondition = set(
    'op',
    newOperator,
    conditionObject.condition[conditionIndex]
  );
  const newConditions = update(
    conditionIndex,
    newCondition,
    conditionObject.condition
  );
  const newConditionObject = set('condition', newConditions, conditionObject);

  return newConditionObject;
};

export const setInPages = (
  conditionIndex: number,
  newInPages: IUIPage[],
  conditionObject: IExtendedConditionObject
): IExtendedConditionObject => {
  const newCondition = set(
    'in',
    newInPages,
    conditionObject.condition[conditionIndex]
  );
  const newConditions = update(
    conditionIndex,
    newCondition,
    conditionObject.condition
  );
  const newConditionObject = setCondition(newConditions, conditionObject);

  return newConditionObject;
};

export const setExtendedCondition = (
  conditionIndex: number,
  newExtendedCondition: IExtendedCondition,
  extendedConditionObject: IExtendedConditionObject
) => {
  const newConditions = update(
    conditionIndex,
    newExtendedCondition,
    extendedConditionObject.condition
  );

  const newExtendedConditionObject = set(
    'condition',
    newConditions,
    extendedConditionObject
  );

  return newExtendedConditionObject;
};
